export const ELEMENT_DIVIDER = 'elementDivider';
